<template>
    <div>
        
        <!-- Filter Start -->
        <div class="innerBox mb-4">
            <div class="row">
                <div class="col-md-9">
                    <input
                        class="form-control filterInput"
                        type="search"
                        placeholder="Masukkan Nomor TO/NOPOL"
                        aria-label="Search"
                        style="font: normal normal normal 16px/25px Poppins;"
                        v-model="filter.search"
                    >
                </div>
                <div class="col-md-3 text-right">
                    <button
                        class="btn"
                        type="button"
                        style="background-color: #1B698E; color: white; padding: 0 50px; height: 100%; font-weight: bold; font: normal normal 600 14px/21px Poppins;"
                        @click="fetchData"
                    >CARI</button>
                </div>
            </div>
        </div>
        <!-- Filter End -->

        <!-- Title & Option Buttons Start -->
        <div class="row">
            <div class="col-md-3">
                <button 
                    class="btn btn--mpm--transporter" 
                    @click="requestFullScreen"
                    style="font: normal normal normal 12px/18px Poppins;">Full Screen</button>
            </div>
            <div class="col-md-4 text-center" style="display: flex; flex-direction: column-reverse;">
                <h3 
                    style="font: normal normal normal 16px/25px Poppins;">Dashboard Tracking</h3>
            </div>
            <div class="col-md-1"></div>
            <div class="col-md-4">
                <div class="d-flex">
                    <div 
                        class="col-4" 
                        style="display: flex; align-items: center; font: normal normal normal 12px/18px Poppins;">
                        <span style="font: normal normal normal 12px/18px Poppins;">Filter Tanggal</span>
                    </div>
                    <div class="col-8">
                        <flat-pickr
                            :config="datePickr"
                            placeholder="Select Date"
                            v-model="filter.date"
                            style="font: normal normal normal 12px/18px Poppins;"
                        ></flat-pickr>
                    </div>
                </div>
            </div>
        </div>
        <!-- Title & Option Buttons End -->

        <!-- Stats Start -->
        <hr style="background: #EFEFEF;">
        <div class="row mb-4">
            <div class="col-lg-3 col-md-6">
                <div class="innerBox">
                    <truck-tracking-stats
                        title="Validasi Truck"
                        :value="data.stats ? data.stats.validasi != null ? numberWithCommas(data.stats.validasi) : 'N/A' : 'Loading...'"
                        icon="truckCheck"
                        style="font: normal normal normal 20px/30px Poppins;"
                    ></truck-tracking-stats>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="innerBox">
                    <truck-tracking-stats
                        title="Pengecekan"
                        :value="data.stats ? data.stats.pengecekan != null ? numberWithCommas(data.stats.pengecekan) : 'N/A' : 'Loading...'"
                        icon="clipboardCheck"
                        style="font: normal normal normal 20px/30px Poppins;"
                    ></truck-tracking-stats>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="innerBox">
                    <truck-tracking-stats
                        title="Pengiriman"
                        :value="data.stats ? data.stats.pengiriman != null ? numberWithCommas(data.stats.pengiriman) : 'N/A' : 'Loading...'"
                        icon="truck"
                        style="font: normal normal normal 20px/30px Poppins;"
                    ></truck-tracking-stats>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="innerBox">
                    <truck-tracking-stats
                        title="Idle"
                        :value="data.stats ? data.stats.idle != null ? numberWithCommas(data.stats.idle) : 'N/A' : 'Loading...'"
                        style="font: normal normal normal 20px/30px Poppins;"
                    ></truck-tracking-stats>
                </div>
            </div>
        </div>
        <hr style="background: #EFEFEF;">
        <!-- Stats End -->

        <!-- Daftar Pengiriman Start -->
        <div class="row">
            <h4 class="col-md-2" style="font: normal normal normal 20px/30px Poppins;">Daftar Pengiriman</h4>
            <div class="row mt-2 ml-2">
                <h2 class="row-md-2 mr-2" style="font: normal normal normal 14px/21px Poppins;"><span class="dot--cancel mr-1"></span>Dibatalkan</h2>
                <h2 class="row-md-2 ml-2" style="font: normal normal normal 14px/21px Poppins;"><span class="dot--terkirim mr-1"></span>Terkirim</h2>
            </div>
        </div>
        <div class="daftar--pengiriman" v-if="data.daftarPengiriman">
            <template v-if="data.daftarPengiriman.length > 0">
                <div v-for="dat in data.daftarPengiriman">
                    <tracking-row-status
                        :data="dat"
                    ></tracking-row-status>
                </div>
            </template>
            <div style="min-height: 400px; display: flex; align-items: center; justify-content: center;" v-else>
                <p style="margin: 0; font-size: 40px; text-shadow: 2px 2px 2px grey">No Data</p>
            </div>
        </div>
        <div style="min-height: 400px; display: flex; align-items: center; justify-content: center;" v-else>
            <p style="margin: 0; font-size: 40px; text-shadow: 2px 2px 2px grey">Loading...</p>
        </div>
        <!-- Daftar Pengiriman End -->

    </div>
</template>

<script>
    import qs from 'qs'
    import moment from 'moment'

    import TruckTrackingStats from './children/TruckTrackingStats'
    import trackingRowStatus from './children/trackingRowStatus'

    export default {
        metaInfo : {
            title : 'Truck Tracking'
        },
        data () {
            return {
                data : {
                    stats : null,
                    daftarPengiriman : null,
                },
                datePickr: {
                    dateFormat: "Y-m-d",
                    altInput: true,
                    altFormat: "d/m/Y",
                    altInputClass: 'form-control input mpm--transporter--flatpickr'
                },
                filter : {
                    search : null,
                    date : moment().format("YYYY-MM-DD")
                },
                dummyData : null,
            }
        },
        components : {
            TruckTrackingStats,
            trackingRowStatus
        },
        mounted () {
            // this.generateDummyData();
            this.fetchData();
        },
        watch : {
            'filter.date' : {
                deep : true,
                handler : 'fetchData',
            },
        },
        methods : {
            requestFullScreen() {
                var element = document.body; // Make the body go full screen.

                // Supports most browsers and their versions.
                var requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen;

                if (requestMethod) { // Native full screen.
                    requestMethod.call(element);
                } else if (typeof window.ActiveXObject !== "undefined") { // Older IE.
                    var wscript = new ActiveXObject("WScript.Shell");
                    if (wscript !== null) {
                        wscript.SendKeys("{F11}");
                    }
                }
            },
            generateDummyData () {
                let dummyData = []

                for (var i = 0; i < 20; i++) {
                    let progress = this.randomInt(1, 20)
                    dummyData.push({
                        "current_route" : `W ${this.randomInt(1000, 9999)} P`,
                        "rute" : `Batu ${i + this.randomInt(0, 1000)}`,
                        "jumlah_dealer_terkirim" : progress,
                        "jumlah_dealer" : progress + this.randomInt(0, 20)
                    })
                }

                this.dummyData = dummyData;
            },
            fetchData() {
                //Reset Data
                for (var i in this.data) this.data[i] = null;

                //Reset Search To null if empty string
                if (this.filter.search == "") this.filter.search = null;

                //Get Stats
                this.$http.get(`/api/monitoring/stats?${qs.stringify(this.filter, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp)=>{
                    this.data.stats = resp.data.data;
                })
                .catch((err)=>{console.log(err)});

                //Get Daftar Pengiriman
                this.$http.get(`/api/monitoring/daftar-pengiriman?${qs.stringify(this.filter, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp)=>{
                    this.data.daftarPengiriman = resp.data.data;
                })
                .catch((err)=>{console.log(err)});

            }
        }
    }
</script>

<style scoped>
    .innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
    }
    
    .filterInput::placeholder {
        color: #BBBBBB;
        font: normal normal normal 16px/25px;
    }

    .daftar--pengiriman {
        padding-right: 20px;
        max-height: 40vh;
        overflow-x: hidden;
    }
    .daftar--pengiriman::-webkit-scrollbar{
        width: 1em;
    }
    .daftar--pengiriman::-webkit-scrollbar-track{
        background-color:#F9F9F9;
        border-radius: 20px;
    }
    .daftar--pengiriman::-webkit-scrollbar-thumb{
        background-color:#A2A2A2;
        border: 2px solid #707070;
        border-radius: 20px;
    }

    .dot--terkirim {
        height: 14px;
        width: 14px;
        background-color: #61FB50;
        border-radius: 10%;
        display: inline-block;
    }
    
    .dot--cancel {
        height: 14px;
        width: 14px;
        background-color: #FF919E;
        border-radius: 20%;
        display: inline-block;
    }
</style>